import { useEffect, useState } from "react";
import { NumberOptions } from "../../../types";
import { QueryFormValues, QueryIFilter } from "../../types";
import useGetMe from "../../../../../hooks/useCurrentUser";
import { formatDateFilter } from "../../../../../utils/generalFormat";
import { Button, Col, Container, Label } from "../../../styles";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { Row, Select } from "antd";
import { Field, Form, Formik } from "formik";


export const FormFilter: React.FC<QueryIFilter> = (props: QueryIFilter) => {
  const { getFilters } = props;
  const [isLoading] = useState<boolean>(false);
  const user = useGetMe();

  const getInitialValue = (): QueryFormValues => {
    const today = new Date();
    const initialDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0
    );
    const finalDate = new Date(
      initialDate.getFullYear(),
      initialDate.getMonth(),
      initialDate.getDate(),
      23,
      59,
      59
    );

    return {
      merchantId: "",
      initialDate: formatDateFilter(initialDate),
      finalDate: formatDateFilter(finalDate),
      document: "",
      hash: "",
      urValueFilter: 0,
      committedValueFilter: 0,
    };
  };

  const getContractEffects = async (submit: any) => {
    if (submit.initialDate === "") {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      submit.initialDate = formatDateFilter(date);
    } else {
      submit.initialDate = formatDateFilter(submit.initialDate);
    }

    if (submit.finalDate === "") {
      const date = new Date();
      date.setHours(23, 59, 59, 59);
      submit.finalDate = formatDateFilter(date);
    } else {
      submit.finalDate = formatDateFilter(submit.finalDate);
    }

    getFilters(submit);
    return submit;
  };

  const handleChangeInitialDate = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = e.target;
    const date = new Date(`${value}T00:00:00`);
    setFieldValue("initialDate", formatDateFilter(date));
  };

  const handleChangeFinalDate = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = e.target;
    const date = new Date(`${value}T23:59:59`);
    setFieldValue("finalDate", formatDateFilter(date));
  };

  useEffect(() => {
    getContractEffects(getInitialValue());
  }, []);

  const urValueOptions: NumberOptions[] = [
    { label: "Valor Da UR", value: 0 },
    { label: "Valor Da UR > R$ 0.00", value: 1 },
    { label: "Valor Da UR = R$ 0.00", value: 2 },
  ];

  const committedValueOptions: NumberOptions[] = [
    { label: "Valor Comprometido", value: 0 },
    { label: "Valor Comprometido > R$ 0.00", value: 1 },
    { label: "Valor Comprometido = R$ 0.00", value: 2 },
  ];

  return (
    <Container style={{ padding: "0px" }}>
      <LoadingOverlay show={isLoading} relative />

      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValue()}
        onSubmit={async (values: any) => {
          await getContractEffects(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  placeholder="Data Inicial"
                  step="1"
                  name="initialDate"
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeFinalDate(e, setFieldValue)}
                  placeholder="Data Final"
                  step="1"
                  name="finalDate"
                />
              </Col>

              {(user.userType === 3 ||
                user.userType === 6 ||
                user.userType === 7) && (
                <>
                  <Col>
                    <Field
                      type="text"
                      name="merchantId"
                      placeholder="Cód. Lojista."
                    />
                  </Col>

                  <Col>
                    <Field type="text" name="document" placeholder="CPF/CNPJ" />
                  </Col>
                </>
              )}

              <Col>
                <Field type="text" name="hash" placeholder="Cód. Hash" />
              </Col>

              <Col>
                <Select
                  value={values.urValueFilter}
                  style={{ width: "100%" }}
                  onChange={(value) => setFieldValue("urValueFilter", value)}
                  options={urValueOptions}
                />
              </Col>

              <Col>
                <Select
                  value={values.committedValueFilter}
                  style={{ width: "100%", minWidth: "200px" }}
                  dropdownStyle={{ minWidth: "250px" }}
                  onChange={(value) => setFieldValue("committedValueFilter", value)}
                  options={committedValueOptions}
                />
              </Col>

              <Col>
                <Button htmlType="submit" style={{ marginLeft: "16px" }}>
                  Consultar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};